const PDF_CHUNK_SIZE = 128 * 1024;

function getBridge(source) {
  const browserWindow =
    source || (typeof window !== "undefined" ? window : undefined);
  const bridge = browserWindow && browserWindow.HeatMatBridge;

  return bridge && typeof bridge.postMessage === "function" ? bridge : null;
}

export function isHeatMatApp(source) {
  return getBridge(source) !== null;
}

function post(bridge, message) {
  bridge.postMessage(JSON.stringify(message));
}

function readBlobAsBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      resolve(result.substring(result.indexOf(",") + 1));
    };
    reader.onerror = () => reject(reader.error || new Error("File read failed"));
    reader.readAsDataURL(blob);
  });
}

export async function sendPdfBlobToHeatMatApp(
  blob,
  fileName = "HEATMAT_installation_recommendations.pdf",
  source
) {
  const bridge = getBridge(source);
  if (!bridge) return false;

  const transferId = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const totalChunks = Math.max(1, Math.ceil(blob.size / PDF_CHUNK_SIZE));

  try {
    post(bridge, {
      type: "pdf-start",
      transferId,
      fileName,
      byteLength: blob.size,
      totalChunks,
    });

    for (let index = 0; index < totalChunks; index += 1) {
      const start = index * PDF_CHUNK_SIZE;
      const chunk = blob.slice(start, Math.min(start + PDF_CHUNK_SIZE, blob.size));
      const data = await readBlobAsBase64(chunk);

      post(bridge, {
        type: "pdf-chunk",
        transferId,
        index,
        data,
      });
    }

    post(bridge, { type: "pdf-complete", transferId });
    return true;
  } catch (error) {
    post(bridge, {
      type: "pdf-error",
      transferId,
      message: error instanceof Error ? error.message : "PDF transfer failed",
    });
    throw error;
  }
}
